/**
 * Drawing utility functions and custom brush helpers for the Smile Designer.
 */

/**
 * Configure a Fabric.js PencilBrush for whitening mode.
 * Paints with white at low opacity using lighten composite operation.
 */
export const configureWhiteningBrush = (canvas, options = {}) => {
  const { PencilBrush } = require('fabric');
  const brush = new PencilBrush(canvas);
  brush.color = 'rgba(255, 255, 255, 0.2)';
  brush.width = options.width || 30;
  brush.strokeLineCap = 'round';
  brush.strokeLineJoin = 'round';
  return brush;
};

/**
 * Apply whitening composite operation to a path after creation.
 * Called in the canvas path:created handler when whitening mode is active.
 */
export const applyWhiteningToPath = (path) => {
  path.globalCompositeOperation = 'lighten';
  path.selectable = false;
  path.evented = false;
};

/**
 * Configure a standard drawing brush.
 */
export const configureDrawingBrush = (canvas, options = {}) => {
  const { PencilBrush } = require('fabric');
  const brush = new PencilBrush(canvas);
  brush.color = options.color || '#000000';
  brush.width = options.width || 3;
  brush.strokeLineCap = 'round';
  brush.strokeLineJoin = 'round';
  return brush;
};

/**
 * Hex color to rgba string.
 */
export const hexToRgba = (hex, opacity = 1) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

/**
 * Default drawing tool settings.
 */
export const DEFAULT_DRAW_SETTINGS = {
  brushColor: '#FFFFFF',
  brushWidth: 5,
  brushOpacity: 1,
  eraserWidth: 20,
  whiteningWidth: 30,
  whiteningOpacity: 0.2,
  fontSize: 16,
  fontColor: '#000000',
  shapeStroke: '#000000',
  shapeFill: 'transparent',
  shapeStrokeWidth: 2,
};
